import { PERMANENT_LOWER, PERMANENT_UPPER } from "@/components/charting/dentition";
import { multiToothKindOf } from "@/lib/procedureFlags";

export const DENTURE_ARCH_FDIS = Object.freeze({
  upper: PERMANENT_UPPER.map(String),
  lower: PERMANENT_LOWER.map(String),
});

export function isDentureProcedure(procedure) {
  return ["full_denture", "partial_denture"].includes(multiToothKindOf(procedure));
}

export function isToothRemovalProcedure(procedure) {
  return procedure?.is_extraction === true || procedure?.completion_finding_code === "missing";
}

export function fdiArch(fdi) {
  const quadrant = Math.floor(Number(fdi) / 10);
  if ([1, 2, 5, 6].includes(quadrant)) return "upper";
  if ([3, 4, 7, 8].includes(quadrant)) return "lower";
  return null;
}

function dentureGroupFromRow(row) {
  const installed = row?.installed === true;
  const isFull = row.kind === "full";
  return {
    id: `${installed ? "installed" : "active"}-denture-${row.id}`,
    sourceItemId: String(row.id),
    kind: isFull ? "full_denture" : "partial_denture",
    label: isFull ? "DENTURE" : "RPD",
    color: isFull ? "#6d28d9" : "#047857",
    installed,
    teeth: isFull
      ? [...(DENTURE_ARCH_FDIS[row.arch] || [])]
      : (Array.isArray(row.teeth) ? row.teeth : [])
          .map((tooth) => String(typeof tooth === "object" ? tooth?.tooth_number : tooth))
          .filter(Boolean),
    rolesByFdi: {},
  };
}

export function buildDentureChartGroups(rows) {
  if (!Array.isArray(rows)) return [];
  return rows
    .filter((row) => ["full", "partial"].includes(row?.kind))
    // If an installed and an active replacement overlap, show the
    // active case scope first so the doctor sees today's work intent.
    .sort((a, b) => Number(a?.installed === true) - Number(b?.installed === true))
    .map(dentureGroupFromRow)
    .filter((group) => group.teeth.length > 0);
}

export function buildInstalledDentureGroups(rows) {
  return buildDentureChartGroups(rows).filter((group) => group.installed);
}
